<script setup>
import {computed, defineModel, defineProps} from 'vue'
import { useI18n } from "vue-i18n";

const props = defineProps({
    rules: {
        type: Array,
        default: () => []
    },
    readonly: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    }
});

const { t } = useI18n();

const model = defineModel({ default: '' })

const inputClasses = computed(() => ({
    'field-default': true,
    'input-disabled': props.readonly
}))

const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')

const combinedRules = computed(() => {
    const rules = [...props.rules]
    if (props.required) rules.unshift(requiredRule)
    return rules
})
</script>
<template>
    <div class="date-input">
        <v-date-input
            v-model="model"
            class="field-default"
            prepend-icon=""
            prepend-inner-icon="$calendar"
            variant="outlined"
            :rules="combinedRules"
            :class="inputClasses"
            :readonly="readonly"
        ></v-date-input>
    </div>
</template>
